import {
  SET_EDITING_TASK_ID,
  SET_TASKLIST_REORDERING_TYPE,
} from 'constants/actions';

function setTaskListReorderingType(reorderingType) {
  return {
    type: SET_TASKLIST_REORDERING_TYPE,
    reorderingType,
  };
}

function setEditingTaskId(taskId) {
  return {
    type: SET_EDITING_TASK_ID,
    taskId,
  };
}

export { setEditingTaskId, setTaskListReorderingType };
